import AmioHttpService from './amio-http.service'

class RequestsService extends AmioHttpService {

  saveIntentSuggestion(requestId, suggestedIntent) {
    return this.requestPut(`/requests/${requestId}/intent-suggestion`, {
      suggested_intent: suggestedIntent
    })
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getIntentSuggestion(requestId) {
    return this.requestGet(`/requests/${requestId}/intent-suggestion`)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

function adapt(intentSuggestion) {
  return {
    originalIntent: intentSuggestion.original_intent,
    suggestedIntentPlatformId: intentSuggestion.suggested_intent,
    createdOn: intentSuggestion.created_on
  }
}

export default new RequestsService()
